import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 540px;
  margin: 59px auto;
  padding: 0 16px;
`;

export default Container;
